import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { FormattedMessage } from '@flipster/i18n';
import { Link } from '@flipster/i18n/routing';
import { useOverlayItem } from '@flipster/overlay';
import { css } from '@flipster/styled-system/css';
import { hstack } from '@flipster/styled-system/patterns';
import DocumentHistoryIcon from '@flipster/ui/assets/svgs/document-history.svg';

import { CurrencyDisplay } from '../../../misc/display';
import { useV1Currencies } from '../../currency/use-v1-currencies';
import { walletModalBunja } from '../shared/core/state';

export const Header = () => {
  const { close } = useOverlayItem();
  const { selectedCurrencyAtom } = useBunja(walletModalBunja);
  const { currenciesKeyByCurrency } = useV1Currencies();

  const selectedCurrency = useAtomValue(selectedCurrencyAtom);

  const currency = currenciesKeyByCurrency?.[selectedCurrency ?? ''];
  return (
    <div className={wrapperStyle}>
      <CurrencyDisplay
        currency={selectedCurrency!}
        icon={<CurrencyDisplay.Icon size={24} space={0} />}
        css={{ mr: 12 }}
      />
      <h2>
        <div className={hstack({ gap: 8 })}>
          <FormattedMessage id='Deposit.r250401.Deposit_symbol' values={{ symbol: currency?.englishName }} />
          <Link href='/history/transaction/deposit' onClick={close} className={depositHistoryStyle}>
            <DocumentHistoryIcon />
          </Link>
        </div>
      </h2>
    </div>
  );
};

const wrapperStyle = css({
  display: 'flex',
});

const depositHistoryStyle = css({
  mt: '4px',
  color: 'gray.white',
});
